import React from "react";
import { AuthorsProps } from "@/types/modules/post/contentComponents";
import { Headline } from "@/components/ui-kit/Headline";
import { AuthorListCard } from "@/components/modules/Author/AuthorListCard";

export const Authors: React.FC<AuthorsProps> = ({ title, authors }) => {
  return (
    <div className="my-[48px] md:my-[64px]">
      {title && <Headline title={title} />}
      <div className="grid md:grid-cols-3 md:gap-x-[15px] md:gap-y-[32px] md:pt-[8px]">
        {authors?.map((author) => <AuthorListCard key={`author-card-${author?.id}`} author={author} />)}
      </div>
    </div>
  );
};
